<template>
    <v-layout _card-follow column v-scrollanim="{ bEnt: 'app-bg-white', enter: 'bg-animate app-bg-sand' }">
        <v-flex class="d-flex align-center">
            <v-container grid-list-xl>
                <v-layout row wrap text-xs-center>
                    <!-- Subscribe Section -->
                    <div class="subscribe-section flex flex-column justify-center">
                        <h3 class="mb-3">Join our growing community and get our<br> blogposts delivered straight to your inbox</h3>
                        <v-btn color="primary" to="/register">Register</v-btn>
                        <!-- <clubhouse-subscribe class="ma-auto"></clubhouse-subscribe> -->
                    </div>
                    
                    <!-- Follow Section -->
                    <div class="follow-section flex flex-column align-center">
                        <h2 class="mb-4 text-center">Follow us on</h2>
                        <div class="follow-buttons d-flex flex-wrap justify-center gap-4 pa-1">
                            <v-btn color="primary"
                                   :href="facebook.param | text"
                                   target="_blank"
                                   outline>
                                <div class="_card-follow--brandshape mb-2 pt-4">
                                    <app-brandshape color="var(--sand)"
                                                    :width="$vuetify.breakpoint.xsOnly ? '30px' : '40px'"
                                                    :height="$vuetify.breakpoint.xsOnly ? '30px' : '40px'">
                                        <div class="brandshape--icon icon_facebook">
                                            <app-svg-icon name="ui/NG_FACEBOOK"
                                                          :height="$vuetify.breakpoint.xsOnly ? '15px' : '25px'"
                                                          color="var(--white)"></app-svg-icon>
                                        </div>
                                    </app-brandshape>
                                </div>Facebook
                            </v-btn>
                            <v-btn :href="instagram.param | text"
                                   target="_blank"
                                   color="primary" outline>
                                <div class="_card-follow--brandshape mb-2 pt-4">
                                    <app-brandshape color="var(--sand)"
                                                    :width="$vuetify.breakpoint.xsOnly ? '30px' : '40px'"
                                                    :height="$vuetify.breakpoint.xsOnly ? '30px' : '40px'">
                                        <div class="brandshape--icon icon_instagram">
                                            <app-svg-icon name="ui/NG_INSTAGRAM"
                                                          :height="$vuetify.breakpoint.xsOnly ? '15px' : '25px'"
                                                          color="var(--white)"></app-svg-icon>
                                        </div>
                                    </app-brandshape>
                                </div>Instagram
                            </v-btn>
                        </div>
                    </div>
                </v-layout>
            </v-container>
        </v-flex>
        <!--BACKGROUND ELEMENTS-->
        <v-flex v-if="$vuetify.breakpoint.mdAndUp"
                class="_card-follow--bg-elements">
          <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
            <app-svg-icon name="brand/NG_PETS"
                          color="var(--green)"
                          class="svg-icon--pets"></app-svg-icon>
          </div>
          <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
            <app-svg-icon name="brand/NG_ENGAGED"
                          color="var(--blue)"
                          class="svg-icon--engaged"></app-svg-icon>
          </div>
          <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
            <app-svg-icon name="patterns/NG_Pattern-04"
                          color="none var(--orange) none"
                          class="svg-icon--pattern-04"></app-svg-icon>
          </div>
          <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
            <app-svg-icon name="patterns/NG_Pattern-14"
                          color="none var(--yellow) none"
                          class="svg-icon--pattern-14"></app-svg-icon>
          </div>

        </v-flex>
    </v-layout>
</template>

<script>
  import AppBrandshape from '../app-brandshape'
  import ClubhouseSubscribe from '../../views/app/clubhouse/share/clubhouse-subscribe.vue'
  export default {
    name: 'app-card-follow-us',
    components: {AppBrandshape,ClubhouseSubscribe},
              mounted () {
    document.title = "Blog – A Supportive Community for Nannies & Families || NannyGranny"
    const updateMetaTag = (name, content) => {
        let metaTag = document.querySelector(`meta[name="${name}"]`)
        if (metaTag) {
            metaTag.setAttribute('content', content)
        } else {
            metaTag = document.createElement('meta')
            metaTag.setAttribute('name', name)
            metaTag.setAttribute('content', content)
            document.head.appendChild(metaTag)
        }
    }
    updateMetaTag('description', "Explore our blog to connect with nannies and families, share experiences, learn new skills, and grow together in a supportive childcare community for everyone.")
    updateMetaTag('title', 'Blog – A Supportive Community for Nannies & Families || NannyGranny')
},
    computed: {
      links () {
        return this.$store.getters['page/content']('social_links')
      },
      facebook () {
        return this.links.filter(item => item.slug === 'facebook')[0] || {}
      },
      instagram () {
        return this.links.filter(item => item.slug === 'instagram')[0] || {}
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .facebook-follow-container {
        @media (max-width 599px) {
            padding-top 50px !important
        }
    }

    .instagram-follow-container {
        @media (max-width 599px) {
            padding-bottom 50px !important
        }
    }

    ._card-follow
        overflow hidden
        position relative
        background-color var(--sand)
        .container
            max-width 990px
        .v-btn
            min-width 180px
        &--bg
            .svg-icon
                position absolute
                width 74px
                height 70px
                &--active
                    top 500px
                    right 20px
                    transform rotate(25deg)
                    @media (max-width 760px) {
                      display none
                    }                  
        &--brandshape
            max-width 60px
            height 60px
            @media (min-width 600px)
                max-width 78px
                height 78px
            .brandshape--icon
                height 100%
                display flex
                align-items center
                justify-content center
                &.icon_facebook
                    background-color var(--yellow)
                &.icon_instagram
                    background-color var(--orange)
        &--bg-elements
            max-height 1px
            .svg-icon
                position absolute
                width 74px
                height 70px
                &--pets
                    width 60px
                    // top 90px
                    top -295px
                    transform rotate(25deg)
                    right calc(50% - 35%);
                    @media (max-width 1440px) {
                      right: calc(50% - 40%);
                    }
                    @media (max-width 1024px) {
                      display: none;
                      right: calc(50% - 50%);
                    }
                &--engaged
                    // bottom 50px
                    bottom 60px
                    left calc(50% - 43%);
                    @media (max-width 1440px) {
                      left: calc(50% - 40%);
                    }
                    @media (max-width 1024px) {
                      display: none;
                      left: calc(50% - 50%);
                    }
                &--pattern-04
                    width 155px
                    height 150px
                    left -45px
                    // top 80px
                    top -250px
                    transform rotate(-125deg)
                &--pattern-14
                    width 220px
                    height 150px
                    right -65px
                    bottom 0
</style>



// WEBPACK FOOTER //
// src/components/app-card/app-card-follow-us.vue